var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCarouselArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  className: "carousel-arrow-left_svg__lucide carousel-arrow-left_svg__lucide-arrow-left"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m12 19-7-7 7-7M19 12H5"
})));
export { SvgCarouselArrowLeft as ReactComponent };
export default __webpack_public_path__ + "f1e7a736bf7b4a70f03cbcb113b8e36e.svg";